/**
 * 361 Sleep — Section 14
 * Soft fade-up for the engineering composition diagram.
 */
(function () {
  'use strict';

  var BOOTED = false;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function whenGsap(fn) {
    if (window.gsap && window.ScrollTrigger) {
      fn(window.gsap, window.ScrollTrigger);
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (window.gsap && window.ScrollTrigger) {
        clearInterval(timer);
        fn(window.gsap, window.ScrollTrigger);
      } else if (tries > 80) {
        clearInterval(timer);
      }
    }, 50);
  }

  function initSection(section, gsap) {
    var pill = section.querySelector('[data-comp-pill]');
    var views = section.querySelectorAll('[data-comp-view]');
    if (!pill && !views.length) return;

    if (section._comp361Ctx) {
      section._comp361Ctx.revert();
      section._comp361Ctx = null;
    }

    var targets = [];
    if (pill) targets.push(pill);
    Array.prototype.push.apply(targets, Array.prototype.slice.call(views));

    var ctx = gsap.context(function () {
      var mm = gsap.matchMedia();

      mm.add('(prefers-reduced-motion: reduce)', function () {
        gsap.set(targets, { clearProps: 'all' });
      });

      mm.add('(prefers-reduced-motion: no-preference)', function () {
        gsap.from(targets, {
          opacity: 0,
          y: 34,
          duration: 0.85,
          ease: 'power2.out',
          stagger: 0.16,
          scrollTrigger: {
            trigger: section,
            start: 'top 78%',
            toggleActions: 'play none none none'
          }
        });
      });
    }, section);

    section._comp361Ctx = ctx;
  }

  function boot() {
    whenGsap(function (gsap, ScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger);
      document.querySelectorAll('[data-comp361]').forEach(function (section) {
        initSection(section, gsap);
      });

      if (!BOOTED) {
        BOOTED = true;
        window.addEventListener(
          'load',
          function () {
            ScrollTrigger.refresh();
          },
          { once: true }
        );
      }
    });
  }

  ready(boot);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    if (!root || !root.querySelector) return;
    if (!root.querySelector('[data-comp361]') && !(root.matches && root.matches('[data-comp361]'))) {
      return;
    }
    boot();
  });
})();
